import React, { useContext, useEffect, useState } from "react";
import "./style.scss";
import Button from "../../../common/Button";
import { message, Modal, Pagination, Table, Upload } from "antd";
import {
  useCreateNewInvite,
  useGetAllUsers,
  useUpdateSourceAdmin,
} from "../../../hooks/useUsers";
import { ReactMultiEmail } from "react-multi-email";
const UsersList = () => {
  const [usersList, setUsersList] = useState([]);
  const [pageSize, setPageSize] = useState(15);
  const [pageNum, setPageNum] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [showInviteModal, setShowInviteModal] = useState(false);
  const [menuVisibleId, setMenuVisibleId] = useState(null);
  const [invitedEmails, setInvitedEmails] = useState([]);

  const columns = [
    {
      title: "User Name",
      key: "name",
      align: "center",
      dataIndex: "name",
      render: (_, record, index) => {
        return (
          <div className="">
            {`${record?.name} ${
              record?.lastName != null ? record?.lastName : ""
            }` || ""}
          </div>
        );
      },
    },
    {
      title: "Email",
      key: "email",
      align: "center",
      dataIndex: "email",
      render: (_, record, index) => {
        return <div>{record?.email?.emailId}</div>;
      },
    },
    {
      title: "Role",
      key: "role",
      align: "center",
      dataIndex: "role",
      render: (_, record) => {
        return <div>{record?.isSourceAdmin ? "Admin" : "User"}</div>;
      },
    },
    {
      title: "Action",
      key: "ation",
      align: "center",
      dataIndex: "action",
      render: (_, record) => {
        const isMenuVisible = menuVisibleId === record?._id;
        return (
          <div
            className="show_menu"
            onClick={() => handleShowMenu(record?._id)}
          >
            ...
            {isMenuVisible && (
              <div className="manage_item">
                <button
                  onClick={() => {
                    record?.isSourceAdmin
                      ? handleSourceAdmin(record?._id, false)
                      : handleSourceAdmin(record?._id, true);
                  }}
                >
                  {record?.isSourceAdmin ? "Remove Admin" : "Make Admin"}
                </button>
              </div>
            )}
          </div>
        );
      },
    },
  ];
  const handleSourceAdmin = (id, isSourceAdmin) => {
    let payload = {
      targetUserId: id,
      isSourceAdmin: isSourceAdmin,
    };
    updateSourceAdmin(payload);
  };

  const handleShowMenu = (id) => {
    setMenuVisibleId((prevId) => (prevId === id ? null : id));
  };
  const onSuccessCreateInvite = (res) => {
    if (res.status === 200) {
      setShowInviteModal(false);
      message.success("Invite Sent successfully");
      getAllUsers();
      setInvitedEmails([]);
    }
  };
  const onErrorCreateInvite = (err) => {
    message.error(err);
  };
  const { mutate: createNewInvite } = useCreateNewInvite(
    onSuccessCreateInvite,
    onErrorCreateInvite
  );
  const onSuccessGetAllUsers = (res) => {
    if (res.status === 200) {
      setUsersList(res?.data?.users);
      setTotalCount(res?.data?.totalCount);
    }
  };
  const onErrorGetAllUsers = (err) => {
    console.log(err);
  };
  const { refetch: getAllUsers } = useGetAllUsers(
    "getAllUsers",
    pageNum,
    pageSize,
    onSuccessGetAllUsers,
    onErrorGetAllUsers
  );
  const onSuccessUpdateSourceAdmin = (res) => {
    if (res.status === 200) {
      message.success("User role updated successfully");
      getAllUsers();
    }
  };
  const onErrorUpdateSourceAdmin = (err) => {
    let errorMessage = "Failed to update user role";
    try {
      const errorData = JSON.parse(err?.response?.data);
      errorMessage = errorData?.message || errorMessage;
    } catch (e) {
      console.error("Failed to parse error response:", e);
    }
    message.error(errorMessage);
  };

  const { mutate: updateSourceAdmin } = useUpdateSourceAdmin(
    onSuccessUpdateSourceAdmin,
    onErrorUpdateSourceAdmin
  );
  const onPageChange = (page, size) => {
    if (page !== pageNum) {
      setPageNum(page);
    } else {
      setPageSize(size);
      setPageNum(1);
    }
  };
  const createInvite = () => {
    if (invitedEmails.length === 0) {
      message.error("Please enter email");
      return;
    }
    let payload = {
      emailsToInvite: invitedEmails,
    };
    createNewInvite(payload);
  };

  const getInviteModal = () => {
    return (
      <Modal
        title="Create New Invite"
        open={showInviteModal}
        onCancel={() => setShowInviteModal(false)}
        className="invite_modal_wrapper"
        footer={null}
        width={"70%"}
        height={"40dvh"}
      >
        <div className="invite_modal_container">
          <div className="invite_form_wrapper">
            <ReactMultiEmail
              placeholder="Input your Email Address"
              emails={invitedEmails}
              onChange={setInvitedEmails}
              getLabel={(email, index, removeEmail) => (
                <div data-tag key={index}>
                  {email}
                  {index > 0 && (
                    <span data-tag-handle onClick={() => removeEmail(index)}>
                      ×
                    </span>
                  )}
                </div>
              )}
            />
          </div>
          <div className="action_wrapper">
            <button
              className="cancelBtn"
              onClick={() => setShowInviteModal(false)}
            >
              Cancel
            </button>
            <Button
              width="140px"
              height="50px"
              text="Send Invite"
              handleClick={createInvite}
              isDisabled={invitedEmails.length === 0}
            />
          </div>
        </div>
      </Modal>
    );
  };
  return (
    <div className="user_list_main_wrapper">
      <div className="user_list_content_wrapper">
        <div className="user_list_action_wrapper">
          <Button
            width="210px"
            height="50px"
            text="Create Invite"
            handleClick={() => setShowInviteModal(true)}
          />
        </div>
        <div className="table_content_wrapper">
          <Table
            columns={columns}
            dataSource={usersList}
            scroll={{
              // x: 2100,
              y: `calc(100% )`,
            }}
            className="main_table"
            pagination={false}
          />
        </div>
        <div className="pagination_wrapper">
          <Pagination
            total={totalCount}
            defaultPageSize={10}
            current={pageNum}
            pageSize={pageSize}
            onChange={onPageChange}
          />
        </div>
      </div>
      {showInviteModal && getInviteModal()}
    </div>
  );
};
export default UsersList;
